module.exports = __webpack_public_path__ + "static/media/logo-big.2a7b9728.svg";